import {post, postJson, imagePost, deleteApi} from './axios3'

const RESOURCE_BASE_PATH = '/sellerImage';

// 上传图片
export const uploadImage = p => imagePost('/image/upload', p);

// 添加图片
export const addImage = p => postJson(`${RESOURCE_BASE_PATH}`, p);

// 删除图片
export const delImage = id => deleteApi(`${RESOURCE_BASE_PATH}/${id}`);

// 获取图片库列表
export const getList = p => postJson(`${RESOURCE_BASE_PATH}/list`, p);